
import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

import FormIcon from './FormIcon';
import LayoutIcon from './LayoutIcon';
import AllIcon from './AllIcon';
import DesignIcon from './DesignIcon';

import './Navbar.css';

class Navbar extends Component {
  render() {
    return (
      <nav className="main-nav">
        <ul>
          <li className='all'><NavLink exact to='/all'><AllIcon />All</NavLink></li>
          <li className='forms'><NavLink to='/forms'><FormIcon />Forms</NavLink></li>
          <li className='layout'><NavLink to='/layout'><LayoutIcon />Layout</NavLink></li>
          <li className='design'><NavLink to='/design'><DesignIcon />Design</NavLink></li>
        </ul>
      </nav>
    );
  }
}

export default Navbar;


// WEBPACK FOOTER //
// ./src/Components/Navbar.jsx